import React, { MouseEvent, useState } from "react";
import { HexColorInput, HexColorPicker } from "react-colorful";
import { useSelector } from "react-redux";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";

import Button from "@/components/button";
import { ButtonBar, Module } from "@/components/layouts";
import { ButtonGroup } from "@/components/layouts/button-group";
import { useModal } from "@/hooks/use-modal";
import * as animationActions from "@/lib/state/actions/animation-actions";
import { animationSelector } from "@/lib/state/selectors/animation-selector";
import { useAppDispatch } from "@/lib/state/store";

import ModalTitle from "./modal-title";

const PaletteModal = () => {
  const [currentColourIndex, setCurrentColourIndex] = useState(0);
  const dispatch = useAppDispatch();
  const { palette } = useSelector(animationSelector);
  const { closeModal } = useModal();

  const onSwatchPressed = (e: MouseEvent<HTMLButtonElement>) => {
    const newIndex = parseInt(e.currentTarget.dataset.colourIndex ?? "0", 10);
    setCurrentColourIndex(newIndex);
  };

  const onColorChange = (newHex: string) => {
    dispatch(animationActions.setColourAction(currentColourIndex, newHex));
  };

  const renderSwatches = () => {
    return palette.map((colour, index) => (
      <li key={index}>
        <button
          onClick={onSwatchPressed}
          data-colour-index={index}
          className={`w-8 h-8 rounded-md m-1 ${currentColourIndex === index
            ? "border-white border-4 shadow-md"
            : "border-transparent border-opacity-50 border-4"
            }`}
          style={{ backgroundColor: colour }}
        />
      </li>
    ));
  };

  return (
    <div>
      <ModalTitle>Edit Palette</ModalTitle>
      <Module>
        <ol className="flex flex-wrap justify-center mb-2">
          {renderSwatches()}
        </ol>
        <HexColorPicker
          className="w-auto"
          color={palette[currentColourIndex]}
          onChange={onColorChange}
        />
        <div className="text-center mt-1">
          Hex code:{" "}
          <HexColorInput
            color={palette[currentColourIndex]}
            onChange={onColorChange}
            className="w-20 rounded-md shadow-inner p-1 border border-gray-300"
          />
        </div>
      </Module>
      <ButtonBar>
        <ButtonGroup align="right">
          <Button
            icon={faCheckCircle}
            onClick={closeModal}
            type="positive"
            rightAlign
          >
            Done
          </Button>
        </ButtonGroup>
      </ButtonBar>
    </div>
  );
};

export default PaletteModal;
